import { createAction, props } from '@ngrx/store';
import { IFilter } from '@app-root-interfaces';

export const changeFilter = createAction(
    '[Filter] Change Filter',
    props<{ payload: { filter: string; key?: string }[] }>()
);

export const changeFilterSuccess = createAction('[Filter] Change Filter success', props<{ filter: IFilter }>());

export const changeSearch = createAction('[Filter] Change search', props<{ search: string }>());

export const changeSearchAll = createAction('[Filter] Change search all', props<{ searchAll: boolean }>());

export const getAllFilters = createAction('[Filter] Get all filters');

export const getAllFiltersSuccess = createAction('[Filter] Get all filters success', props<{ filters: IFilter }>());

export const getAllFiltersFailure = createAction('[Filter] Get all filters failure');

export const resetSearch = createAction('[Filter] Reset search');
